import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/api';

// Async thunks
export const sendMessage = createAsyncThunk(
  'messages/send',
  async (messageData, { rejectWithValue }) => {
    try {
      const response = await apiService.messages.send(messageData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const sendTemplateMessage = createAsyncThunk(
  'messages/sendTemplate',
  async (templateData, { rejectWithValue }) => {
    try {
      const response = await apiService.messages.sendTemplate(templateData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchConversation = createAsyncThunk(
  'messages/fetchConversation',
  async (customerId, { rejectWithValue }) => {
    try {
      const response = await apiService.messages.getConversation(customerId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  conversations: {},
  currentConversation: null,
  loading: false,
  error: null,
  sending: false,
};

const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    addMessage: (state, action) => {
      const { customerId, message } = action.payload;
      if (!state.conversations[customerId]) {
        state.conversations[customerId] = [];
      }
      state.conversations[customerId].push(message);
    },
    updateMessageStatus: (state, action) => {
      const { customerId, messageId, status } = action.payload;
      const messages = state.conversations[customerId];
      if (messages) {
        const message = messages.find(m => m.id === messageId);
        if (message) {
          message.status = status;
        }
      }
    },
    setCurrentConversation: (state, action) => {
      state.currentConversation = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendMessage.pending, (state) => {
        state.sending = true;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.sending = false;
        const { customerId, message } = action.payload;
        if (!state.conversations[customerId]) {
          state.conversations[customerId] = [];
        }
        state.conversations[customerId].push(message);
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.sending = false;
        state.error = action.payload;
      })
      .addCase(fetchConversation.fulfilled, (state, action) => {
        const { customerId, messages } = action.payload;
        state.conversations[customerId] = messages;
        state.currentConversation = customerId;
      });
  },
});

export const {
  addMessage,
  updateMessageStatus,
  setCurrentConversation,
  clearError,
} = messagesSlice.actions;
export default messagesSlice.reducer;

